import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="bg-azul-noche text-white py-20 px-6 relative overflow-hidden flex flex-col items-center text-center min-h-[80vh] justify-center" data-id="element-208">
      {/* Background SVG Elements */}
      <div className="absolute top-10 left-10 opacity-20" data-id="element-209">
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-210">
          <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" data-id="element-211" />
        </svg>
      </div>
      <div className="absolute bottom-20 right-10 opacity-20" data-id="element-212">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-213">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-214" />
        </svg>
      </div>
      <div className="absolute top-32 right-20 opacity-10" data-id="element-215">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-216">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-217" />
        </svg>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-218">
        <FadeIn data-id="element-219">
          <div className="inline-block bg-white/10 text-crema text-sm font-medium px-4 py-1.5 rounded-full mb-8 border border-white/20" data-id="element-220">
            Para mamás con bebés de 0 a 6 meses
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-221">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-222">
            Tu Bebé Puede Dormir 5 Horas Seguidas Esta Semana — Sin Dejarlo
            Llorar Solo
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-223">
          <p className="text-xl md:text-2xl text-crema mb-8 font-serif italic" data-id="element-224">
            La guía honesta de sueño infantil que ojalá te hubieran dado el día
            que nació tu bebé
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-225">
          <p className="text-lg text-white/80 mb-10 max-w-2xl mx-auto" data-id="element-226">
            Para mamás con bebés de 0 a 6 meses que llevan semanas sin dormir
            más de 2 horas seguidas — y que ya intentaron de todo.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-227">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-lila-suave text-azul-noche font-bold text-lg px-8 py-4 rounded-full shadow-[0_0_20px_rgba(201,184,232,0.4)] hover:shadow-[0_0_30px_rgba(201,184,232,0.6)] transition-shadow w-full sm:w-auto" data-id="element-228">
            Quiero Que Mi Bebé Duerma Más Esta Semana →
          </motion.button>
        </FadeIn>
      </div>
    </section>;
}